var ImgEventHandler = /** @class */ (function () {
    function ImgEventHandler() {
        this.handlers = [];
    }
    ImgEventHandler.prototype.on = function (handler) {
        this.handlers.push(handler);
    };
    ImgEventHandler.prototype.off = function (handler) {
        this.handlers = this.handlers.filter(function (h) { return h !== handler; });
    };
    ImgEventHandler.prototype.trigger = function (data) {
        this.handlers.slice(0).forEach(function (h) { return h(data); });
    };
    ImgEventHandler.prototype.expose = function () {
        return this;
    };
    return ImgEventHandler;
}());
export { ImgEventHandler };
